import dashboardSpec from '../../assets/data/dashboardSpec';
import viewDashboardSpec from '../../assets/data/viewDashboardSpec';
import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import getJson from '../../assets/data/dashboardSpec';

const firebaseRef = firebase.database();
export async function openDashboard(
	api,
	reportIndex,
	url,
	reportName,
	uniqueFileName
) {
	try {
		//get the url
		var dashboardSpecRef = firebaseRef.ref(
			'/kavtek_report_information/' +
				PROJECT_CODE.projectCode +
				'/' +
				reportIndex +
				'/dashboardSpec/dataSources/sources/0/module/source/srcUrl'
		);

		await dashboardSpecRef
			.update({
				sourceUrl: url,
			})
			.then(async () => {
				var dashboardSpec;
				await firebaseRef
					.ref(
						'/kavtek_report_information/' +
							PROJECT_CODE.projectCode +
							'/' +
							reportIndex +
							'/dashboardSpec'
					)
					.once('value', (snapshot) => {
						dashboardSpec = snapshot.val();
					});

				console.log('This is the dashboardSpec', dashboardSpec);
				const dashboardApi = await api.dashboard.openDashboard({
					dashboardSpec: dashboardSpec,
				});

				console.log('Dashboard successfully loaded...');
				return dashboardApi;
			});
	} catch (e) {
		console.log('Unable to load that Dashboard: ' + e.message);
		throw e;
	}
}
